import React, { memo, useCallback, useState } from 'react'

import { Icon, Search, TextInput } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setAnimationId } from 'Pods/ThreeDStudio/Store/actions/animateSettings'

import AnimationCard from './Components/AnimationCard/AnimationCard'
import { useOrderedAnimations } from './useOrderedAnimations'

// `notSpaced` rather than `spaceless`: the latter absolutely positions the glyph
// at the input's top-left corner instead of leaving it in the flex flow.
const searchIcon = <Icon notSpaced svgComponent={Search} color="dark" size="small" />

function AnimationLibrary() {
  const t = useTranslation()
  const [query, setQuery] = useState('')
  const animationId = useThreeDStudioStore(state => state.animateSettings.animationId)
  const animations = useOrderedAnimations(query)

  const handleQueryChange = useCallback((event) => {
    setQuery(event.target.value)
  }, [])

  const handleSelect = useCallback((id) => {
    setAnimationId(id === animationId ? null : id)
  }, [animationId])

  return (
    <div className="animation-library">
      <TextInput
        id="animation-library-search"
        isPilot
        size="small"
        placeholder={t('viewerSidebar.enhance.animate.searchPlaceholder')}
        aria-label={t('viewerSidebar.enhance.animate.searchPlaceholder')}
        value={query}
        textInputClassName="animation-library__input"
        onChange={handleQueryChange}
        leadIcon={searchIcon}
      />
      {animations.length === 0 ? (
        <p className="animation-library__empty cgt-body-base">
          {t('viewerSidebar.enhance.animate.noResults')}
        </p>
      ) : (
        <div className="animation-library__grid">
          {animations.map(({ id, name, preview }) => (
            <AnimationCard
              key={id}
              id={id}
              name={name}
              preview={preview}
              isSelected={animationId === id}
              onSelect={handleSelect}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default memo(AnimationLibrary)
